import { FC } from 'react';
import { useActor } from '@xstate/react';

import FareChangeAlertModal from 'src/app/flights/checkout/shared/components/FareChangeAlertModal';
import noop from 'lodash/noop';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import useRetryPaymentService from '../xstate/useRetryPaymentService';
import useAirSelectedItineraryManager from '../hooks/useAirSelectedItineraryManager';
import useGetFareChangeDetails from '../hooks/useGetFareChangeDetails';
import { IRetryPaymentParams } from '../types';

const FareChangeAlertModalContainer: FC = () => {
  const { t: tt } = useTranslation('WEB');
  const retryPaymentService = useRetryPaymentService();
  const [state, send] = useActor(retryPaymentService);
  const { tripId } = useParams<IRetryPaymentParams>();

  const itineraryManager = useAirSelectedItineraryManager();

  const fareChangeDetails = useGetFareChangeDetails();

  if (!state.matches('fareChanged') || !fareChangeDetails) {
    return null;
  }

  const isVoidable = itineraryManager.isItineraryVoidable();

  const handleConfirmCheckout = (): void => {
    send({ type: 'CONFIRM_NEW_REVALIDATE_FIRE' });
  };

  const handleNewSearch = (): void => {
    send({ type: 'CANCEL_NEW_FARE' });
  };

  return (
    <FareChangeAlertModal
      confirmCheckout={handleConfirmCheckout}
      disabled={!tripId}
      toggleConfirmationBox={noop}
      isLoading={false}
      confirmButtonText={tt('Continue with new fare')}
      onCancel={handleNewSearch}
      fareChangeDetails={fareChangeDetails}
      isVoidable={isVoidable}
    />
  );
};

export default FareChangeAlertModalContainer;
